export default __webpack_public_path__ + "static/artist-b283ebbf36981a7d28d6c64b4c7f21c6.svg";